<div class="student-subject-grid">
    <div *ngFor="let subject of subjectTreeChildren" class="student-subject-grid-item">
        <app-link [appRouterLink]="['/subjects' + subject.slug]" class="gtm-student-cloud-topic">
            <img
                class="student-subject-img"
                [src]="subject.posterImage"
                [alt]="subject.posterImageAltText"
            />
            <span class="student-subject-title pt-2">{{ subject.title }}</span>
        </app-link>
    </div>
</div>
